// extracted by mini-css-extract-plugin
export default {"buttons":"saml_config_row_actions-module___buttons___baf7e040"};